import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mb-24" }
const _hoisted_4 = { class: "h1" }
const _hoisted_5 = {
  key: 2,
  class: "mb-64"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-24" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " My Boundary ")
], -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "grid grid--xs flex flex--wrap flex--align-stretch flex--row-gap-medium"
}
const _hoisted_8 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_MyBoundaryCardComponent = _resolveComponent("MyBoundaryCardComponent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.loading)
          ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
          : (_ctx.active_page)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.active_page.title), 1 /* TEXT */)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                ($data.pages.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pages, (page, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: page.id,
                          class: "grid__item a6-12 d6-6"
                        }, [
                          _createVNode(_component_MyBoundaryCardComponent, { page: page }, null, 8 /* PROPS */, ["page"])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, " No content. "))
              ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}